import Box from "@mui/material/Box";

export const LAYER_TRY_SCAN_COLOR = "rgba(124, 58, 237, 0.38)";

// eslint-disable-next-line
export const layerTryScanOverlaySx = {
  position: "absolute",
  inset: 0,
  overflow: "hidden",
  pointerEvents: "none",
  borderRadius: "inherit",
  zIndex: 3,
};

// eslint-disable-next-line
export const layerTryScanSweepSx = {
  position: "absolute",
  top: 0,
  bottom: 0,
  width: "38%",
  background: `linear-gradient(90deg, transparent, ${LAYER_TRY_SCAN_COLOR}, transparent)`,
  animation: "layerTryScanSweep 1.6s ease-in-out infinite",
  "@keyframes layerTryScanSweep": {
    "0%": { transform: "translateX(-120%)" },
    "100%": { transform: "translateX(360%)" },
  },
};

const LayerTryScanOverlay = () => (
  <Box aria-hidden sx={layerTryScanOverlaySx}>
    <Box sx={layerTryScanSweepSx} />
  </Box>
);

export default LayerTryScanOverlay;
